export const VIN_IMMO_HISTORY_LIMIT = 10;

export const IMMO_RECORD_FIELDS = Object.freeze([
  { key: 'Year', label: 'Year' },
  { key: 'REGION', label: 'Region' },
  { key: 'Vehicle', label: 'Vehicle' },
  { key: 'YearRange', label: 'YearRange' },
  { key: 'Feature', label: 'Feature' },
]);

export function splitVinPrefix11(vin) {
  const text = String(vin || '').trim().toUpperCase();
  if (text.length !== 11) {
    return {
      prefix3: text,
      mid5: '',
      suffix3: '',
      isComplete: false,
    };
  }

  return {
    prefix3: text.slice(0, 3),
    mid5: text.slice(3, 8),
    suffix3: text.slice(8, 11),
    isComplete: true,
  };
}

export function isEmptyImmoField(value) {
  if (value === null || value === undefined) return true;
  const text = String(value).trim();
  return text === '' || text.toUpperCase() === 'NULL';
}

export function formatImmoFieldValue(value) {
  if (isEmptyImmoField(value)) return '—';
  return String(value).trim();
}

export function buildImmoRecordFields(record) {
  return IMMO_RECORD_FIELDS.map((field) => ({
    key: field.key,
    label: field.label,
    value: formatImmoFieldValue(record?.[field.key]),
    empty: isEmptyImmoField(record?.[field.key]),
  }));
}
